// perfect for separate cards
// export default function StatusTile({ label, val, type, active }) {
//   const isTrip = type === 'trip' || /trip|fault|low/i.test(label);
//   const isMode = type === 'mode' || /mode|selection/i.test(label);
//   const isHealth = /health|supply/i.test(label);

//   const getPalette = () => {
//     if (isTrip) {
//       return active 
//         ? { color: '#be123c', bg: '#fff1f2', border: '#fecdd3', tag: 'ALARM' } 
//         : { color: '#15803d', bg: '#f0fdf4', border: '#dcfce7', tag: 'OK' };
//     }
//     if (isMode) {
//       return active 
//         ? { color: '#1d4ed8', bg: '#eff6ff', border: '#dbeafe', tag: 'AUTO' } 
//         : { color: '#475569', bg: '#f8fafc', border: '#e2e8f0', tag: 'MANUAL' };
//     }
//     if (isHealth) {
//       return active 
//         ? { color: '#4338ca', bg: '#eef2ff', border: '#e0e7ff', tag: 'HEALTHY' } 
//         : { color: '#b45309', bg: '#fffbeb', border: '#fef3c7', tag: 'WEAK' };
//     }
//     return active 
//       ? { color: '#059669', bg: '#ecfdf5', border: '#d1fae5', tag: 'RUN' } 
//       : { color: '#64748b', bg: '#ffffff', border: '#f1f5f9', tag: 'OFF' };
//   };

//   const theme = getPalette();

//   return (
//     <div className="status-tile-compact" style={{
//       background: theme.bg,
//       border: `1px solid ${theme.border}`,
//       borderTop: `3px solid ${theme.color}`, // Slightly thinner accent bar
//       padding: '12px 10px', // Tightened padding
//       borderRadius: '8px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       minWidth: '130px', // Smaller footprint
//       height: '85px',    // Fixed height for grid alignment
//       transition: 'all 0.2s ease',
//       boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
//     }}>
//       <span style={{ 
//         fontSize: '0.6rem', 
//         fontWeight: '700', 
//         color: '#64748b', 
//         textTransform: 'uppercase',
//         letterSpacing: '0.02rem',
//         marginBottom: '4px',
//         whiteSpace: 'nowrap',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis'
//       }}>
//         {label}
//       </span>
      
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
//         <span style={{ 
//           fontSize: '0.85rem', 
//           fontWeight: '800', 
//           color: theme.color,
//           lineHeight: '1'
//         }}>
//           {val}
//         </span>
        
//         <span style={{ 
//           fontSize: '0.5rem', 
//           fontWeight: '900', 
//           color: theme.color, 
//           padding: '2px 5px',
//           background: `${theme.color}15`, // Very light background of the same color
//           borderRadius: '4px'
//         }}>
//           {theme.tag}
//         </span>
//       </div>
//     </div>
//   );
// }


// import React from 'react';

// const getValColor = (label, val) => {
//   const v = val.toUpperCase();
//   if (v === 'ONLINE' || v === 'RUNNING' || v === 'OK' || v === 'SELECTED') return '#10b981'; // Green
//   if (v === 'OFFLINE' || v === 'STOPPED' || v === 'NOT SELECTED') return '#64748b'; // Slate
//   if (v === 'NOT OK' || v === 'FAULT' || v === 'LOW') return '#ef4444'; // Red
//   if (v === 'AUTO') return '#3b82f6'; // Blue
//   if (v === 'MANUAL') return '#f59e0b'; // Amber
//   return '#1e293b';
// };

// export default function PumpCard({ title, stats }) {
//   return (
//     <div style={{
//       background: '#fff',
//       borderRadius: '12px',
//       padding: '16px',
//       border: '1px solid #e2e8f0',
//       borderTop: `4px solid ${getValColor('', stats[0]?.val)}`,
//       boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
//     }}>
//       <h3 style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '12px', textTransform: 'uppercase' }}>{title}</h3>
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//         {stats.map((s, i) => (
//           <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <span style={{ fontSize: '0.75rem', fontWeight: '500', color: '#475569' }}>{s.label}</span>
//             <span style={{ 
//               fontSize: '0.75rem', 
//               fontWeight: '700', 
//               color: getValColor(s.label, s.val),
//               background: `${getValColor(s.label, s.val)}10`,
//               padding: '2px 8px',
//               borderRadius: '4px'
//             }}>{s.val}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// import React from 'react';

// const getValColor = (val) => {
//   const v = val?.toUpperCase();
//   if (v === 'ONLINE' || v === 'RUNNING' || v === 'OK' || v === 'SELECTED') return '#10b981';
//   if (v === 'OFFLINE' || v === 'STOPPED' || v === 'NOT SELECTED') return '#64748b';
//   if (v === 'NOT OK' || v === 'FAULT' || v === 'LOW') return '#ef4444';
//   if (v === 'AUTO') return '#3b82f6';
//   if (v === 'MANUAL') return '#f59e0b';
//   return '#1e293b';
// };

// export default function PumpCard({ title, stats }) {
//   // Check if this is the Jockey card to apply different layout
//   const isJockey = title.toLowerCase().includes('jockey');

//   return (
//     <div style={{
//       background: '#fff',
//       borderRadius: '12px',
//       padding: '16px',
//       border: '1px solid #e2e8f0',
//       borderTop: `4px solid ${getValColor(stats[0]?.val)}`,
//       boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
//       display: 'flex',
//       flexDirection: 'column',
//       height: '100%'
//     }}>
//       <h3 style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '14px', textTransform: 'uppercase', fontWeight: '700' }}>
//         {title}
//       </h3>
      
//       <div style={{ 
//         display: 'grid', 
//         // If Jockey, use 2 columns to save vertical space; otherwise 1 column
//         gridTemplateColumns: isJockey ? '1fr 1fr' : '1fr', 
//         gap: isJockey ? '10px 20px' : '10px',
//         flex: 1 
//       }}>
//         {stats.map((s, i) => (
//           <div key={i} style={{ 
//             display: 'flex', 
//             justifyContent: 'space-between', 
//             alignItems: 'center',
//             paddingBottom: '4px',
//             borderBottom: '1px solid #f1f5f9'
//           }}>
//             <span style={{ fontSize: '0.7rem', fontWeight: '600', color: '#475569', marginRight: '8px' }}>
//               {s.label}
//             </span>
//             <span style={{ 
//               fontSize: '0.65rem', 
//               fontWeight: '800', 
//               color: getValColor(s.val),
//               background: `${getValColor(s.val)}10`,
//               padding: '2px 6px',
//               borderRadius: '4px',
//               whiteSpace: 'nowrap'
//             }}>
//               {s.val}
//             </span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// import React from 'react';

// // 1. Move the helper function inside the file but outside the component
// const getValColor = (val) => {
//   const v = val?.toUpperCase();
//   if (v === 'ONLINE' || v === 'RUNNING' || v === 'OK' || v === 'SELECTED') return '#10b981'; // Green
//   if (v === 'OFFLINE' || v === 'STOPPED' || v === 'NOT SELECTED') return '#64748b'; // Gray
//   if (v === 'NOT OK' || v === 'FAULT' || v === 'LOW') return '#ef4444'; // Red
//   if (v === 'AUTO') return '#3b82f6'; // Blue
//   if (v === 'MANUAL') return '#f59e0b'; // Amber
//   return '#1e293b';
// };

// export default function PumpCard({ title, stats }) {
//   // 2. Define themeColor INSIDE the component using the props
//   const themeColor = getValColor(stats[0]?.val);

//   return (
// <div 
//       className="scada-card" 
//       style={{
//         "--hover-color": themeColor,
//         background: '#fff',
//         borderRadius: '12px',
//         padding: '24px', // Slightly more padding for a cleaner look
//         border: '1px solid #e2e8f0',
//         borderTop: `6px solid ${themeColor}`, // Thicker top bar looks more SCADA
//         boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
//         display: 'flex',
//         flexDirection: 'column',
//         transition: 'all 0.3s ease',
//         /* REMOVE height: '100%' if it's there */
//         minHeight: '200px' 
//       }}
//     >
//       <h3 style={{ fontSize: '0.75rem', color: '#94a3b8', marginBottom: '15px', letterSpacing: '1px' }}>
//         {title.toUpperCase()}
//       </h3>
      
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//         {stats.map((s, i) => {
//           const isOnline = s.val?.toUpperCase() === 'ONLINE';
//           const valColor = getValColor(s.val);
          
//           return (
//             <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <span style={{ fontSize: '0.8rem', color: '#475569', fontWeight: '500' }}>
//                 {s.label}
//               </span>
//               <div style={{ display: 'flex', alignItems: 'center' }}>
//                 {/* 3. Add Pulse LED if the status is ONLINE */}
//                 {isOnline && <span className="status-led-pulse" />}
//                 <span style={{ 
//                   fontSize: '0.75rem', 
//                   fontWeight: 'bold', 
//                   color: valColor 
//                 }}>
//                   {s.val}
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }
// spaces in card

// Import your pump image at the top
import pumpIcon from '../../assets/water-pump.png';
import settingsIcon from '../../assets/cogwheel.png';  
const getValColor = (val) => {
  if (val === null || val === undefined) return '#94a3b8'; // N/A Silver
  const v = val.toUpperCase();
  
  // Green status
  if (v === 'ONLINE' || v === 'RUNNING' || v === 'OK' || v === 'SELECTED' || v === 'HEALTHY' || v === 'LIVE') return '#10b981';
  // Gray status
  if ( v === 'NOT SELECTED') return '#9c9595';
  // Red status
  if (v === 'OFFLINE' || v === 'STOPPED' || v === 'NOT OK' || v === 'FAULT' || v === 'LOW') return '#ef4444';
  // Blue status
  if (v === 'AUTO') return '#3b82f6';
  // Amber status
  if (v === 'MANUAL') return '#f59e0b';
  
  return '#1e293b';
};





export default function PumpCard({ title, stats }) {
  const isSystemCard = title.toUpperCase() === 'OTHER INDICATIONS';
  const themeColor = isSystemCard ? '#3b82f6' : getValColor(stats[0]?.val);

  return (
    <div 
      className="scada-card" 
      style={{
        "--hover-color": themeColor,
        background: '#fff',
        borderRadius: '10px',
        padding: '16px',
        border: '1px solid #e2e8f0',
        borderTop: `4px solid ${themeColor}`,
        boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '160px'
      }}
    >
      {/* CONDITIONAL ICON: Settings for System, Pump for others */}
      <img 
        src={isSystemCard ? settingsIcon : pumpIcon} 
        alt="icon"
        style={{
          position: 'absolute',
          top: '12px',
          right: '12px',
          /* Settings icon usually looks better slightly smaller (40px) than the pump (50px) */
          width: isSystemCard ? '35px' : '50px', 
          height: 'auto',
          opacity: '0.7',
          zIndex: 0,
          pointerEvents: 'none',
          /* Optional: make settings icon spin slowly for a "live" look */
          animation: isSystemCard ? 'spin 10s linear infinite' : 'none'
        }}
      />

      <h3 style={{ 
        fontSize: '0.9rem', 
        color: '#94a3b8', 
        marginBottom: '16px', 
        letterSpacing: '0.5px',
        fontWeight: 'bold',
        position: 'relative',
        zIndex: 1,
        maxWidth: '70%'
      }}>
        {title.toUpperCase()}
      </h3>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '8px', 
        flexGrow: 1,
        position: 'relative', 
        zIndex: 1 
      }}>
        {stats.map((s, i) => {
          const v = s.val?.toUpperCase();
          const isOnline = v === 'ONLINE' || v === 'HEALTHY' || v === 'RUNNING' || v === 'LIVE';
          const isWarning = v === 'LOW' || v === 'FAULT' || v === 'NOT OK';

          return (
            <div key={i} style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              padding: '4px 0',
              borderBottom: i === stats.length - 1 ? 'none' : '1px solid #f8fafc',
            }}>
              <span style={{ fontSize: '0.75rem', color: '#475569', fontWeight: '500' }}>
                {s.label}
              </span>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {(isOnline || isWarning) && (
                  <span className={isOnline ? "status-led-pulse" : "status-led-error"} 
                    style={{ backgroundColor: getValColor(s.val) }}
                  />
                )}
                <span style={{ 
                  fontSize: '0.75rem', 
                  fontWeight: 'bold', 
                  color: getValColor(s.val) 
                }}>
                  {s.val || 'N/A'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}